import DataSource from "./DataSource";
import SalesOrderDeliveryManager from "./SalesOrderDeliveryManager";
import PriceManager from "./PriceManager";
import SessionManager from "./SessionManager";
import i18n from "../../i18n";

//TODO: read the minimum quantity from a global or product configuration
const minQuantity = 1500;
class SalesBasketManager {

    static get basketItems() {
        if (localStorage.hasOwnProperty('basketItems'))
            return JSON.parse(localStorage.getItem('basketItems'));
        else
            return [];
    }

    static get basket() {

        var basket;

        if (localStorage.hasOwnProperty('basket')) {
            basket = JSON.parse(localStorage.getItem('basket'));
            if (basket.userId === SessionManager.userId) {
                return basket;
            }
            else {
                localStorage.setItem('basketItems', JSON.stringify([]));
            }
        }
        
        // Instantiate and return a new basket
        basket = { userId: SessionManager.userId };
        localStorage.setItem('basket', JSON.stringify(basket));
        return basket;
    }

    static setBasketProperty(_property, _value) {
        let basket = SalesBasketManager.basket;
        basket[_property] = _value;
        localStorage.setItem("basket", JSON.stringify(basket));
    }

    static calcTotalGrossValue() {

        let grossValue = 0.0;
        var items = SalesBasketManager.basketItems;

        for (var i in items) {
            grossValue += SalesBasketManager.calcLineGrossValue(items[i]);
        }

        return grossValue;
    }

    static addItem(_itemData) {

        if (_itemData.Quantity === 0)
            return;
        
        if (_itemData.Quantity < minQuantity && _itemData.Quantity > 0) {
            throw new Error(`Η ελάχιστη ποσότητα παραγγελίας είναι τα ${minQuantity} ${_itemData.SalesUnitId}. Το καλάθι δεν ενημερώθηκε.`);
        }

        var items = SalesBasketManager.basketItems;
        items.push({
            ItemId: _itemData.ItemId,
            ItemCode: _itemData.ItemCode ? _itemData.ItemCode : _itemData.ItemId,
            Description: _itemData.Description,
            Quantity: _itemData.Quantity,
            UnitPrice: _itemData.UnitPrice,
            SalesPrice: _itemData.UnitPrice,
            SalesUnitId: _itemData.SalesUnitId,
            SalesUnitDesc: _itemData.SalesUnitDesc,
            UnitId: _itemData.SalesUnitId,
            GrossValue: SalesBasketManager.calcLineGrossValue(_itemData)
        });

        localStorage.setItem('basketItems', JSON.stringify(items));
    }

    static getItem(_itemIdOrIndex) {
        var items = SalesBasketManager.basketItems;

        if (items) {

            if (typeof _itemIdOrIndex === "string") {
                for (var i = 0; i < items.length; i++) {
                    if (items[i].ItemId === _itemIdOrIndex) {
                        return items[i];
                    }
                }
            }
            else {
                return items[_itemIdOrIndex];
            }
        }

        return null;
    }

    static setItemQuantity(_itemIdOrIndex, _quantity) {

        var items = SalesBasketManager.basketItems;
        var qtyUpdated = false;

        if (items) {

            var index = -1;

            if (typeof _itemIdOrIndex === "string") {
                for (var i = 0; i < items.length; i++) {
                    if (items[i].ItemId === _itemIdOrIndex) {
                        index = i;
                        break;
                    }
                }
            }
            else {
                index = _itemIdOrIndex;
            }

            if (index > -1) {
                var item = items[index];

                if (_quantity === 0 || _quantity === '0')
                    items.splice(index, 1);
                else {

                    if (_quantity < minQuantity && _quantity > 0) {
                        throw new Error(i18n.t(`Η ελάχιστη ποσότητα παραγγελίας είναι τα ${minQuantity} ${item.SalesUnitId}. Το καλάθι δεν ενημερώθηκε.`));
                    }

                    item.Quantity = _quantity;
                    item.GrossValue = item.Quantity * item.UnitPrice;
                }
                qtyUpdated = true;
            }
        }

        if (qtyUpdated)
            localStorage.setItem('basketItems', JSON.stringify(items));

        return qtyUpdated;
    }

    static removeItem(_itemIdOrIndex) {
        var index = -1;
        var items = SalesBasketManager.basketItems;

        if (typeof _itemIdOrIndex === "string") {
            for (var i = 0; i < items.length; i++) {
                if (items[i].ItemId === _itemIdOrIndex) {
                    index = i;
                    break;
                }
            }
        }
        else {
            index = _itemIdOrIndex;
        }

        if (index !== -1 && items) {
            items.splice(index, 1);
            localStorage.setItem('basketItems', JSON.stringify(items));
        }

        if (items.length === 0) {
            SalesBasketManager.clearBasket();
        }

        return items;
    }

    static calcLineGrossValue(_itemData) {

        var grossValue = 0.0;

        if (_itemData.Quantity && _itemData.UnitPrice) {
            grossValue = _itemData.Quantity * _itemData.UnitPrice;
        }

        return parseFloat(grossValue.toFixed(2));
    }

    // Gets the next day available for order delivery
    static getNextDeliveryDate(_skipWeekends, _baseDate) {

        var deliveryMgr = new SalesOrderDeliveryManager(_skipWeekends);
        var deliveryDate = deliveryMgr.calculateExpectedDeliveryDate(SalesBasketManager.basket);

        return deliveryDate;
    }

    static setBasket(_name, _value) {
        var basket = SalesBasketManager.basket;
        basket[_name] = _value;
        localStorage.setItem('basket', JSON.stringify(basket));
    }

    // Submits the sales basket to the server and creates a sales order
    static submitBasket() {

        var basketLines = SalesBasketManager.basketItems;
        var basket = SalesBasketManager.basket;
        var orderData = {
            SalesPointId: SessionManager.salesPointId,
            UserId: SessionManager.userId,
            Details: basketLines,
            TransactionDate: getDateToday(),
            DeliveryDate: basket.DeliveryDate,
            Comment: basket.Comment,
            AEGDistributionRouteId: basket.AEGDistributionRouteId
        };

        return DataSource.persist('OrderHeader', orderData);
    }

    static clearBasket() {
        localStorage.removeItem('basket');
        localStorage.removeItem('basketItems');
    }

    // Initializes the basket lines from a given sales order
    static async initFromSalesOrder(_orderId, _callback) {

        SalesBasketManager.clearBasket();

        var basket = SalesBasketManager.basket;
        SalesBasketManager.setBasketProperty("DeliveryDate", SalesBasketManager.getNextDeliveryDate(true)); //TODO: Skip Weekends from configuration;


        var data = await DataSource.query('OrderDetail', { filter: `OrderHeaderId eq "${_orderId}"`, join: "Order,LineItem,Unit", orderby: "LineNumber" });
        var prices = null;
        try {
            prices = await PriceManager.getPrices();
        }
        catch (er) {
            prices = null;
            console.log(er);
        }

        if (data) {

            var items = [];
            for (var i in data) {

                var line = data[i];
                if (!line.LineItem)
                    continue;

                //Check if Price has changed
                if (prices) {
                    for (var j in prices) {
                        if (prices[j]['ItemId'] === line.LineItem['ItemId']) {
                            if (prices[j]['UnitPrice'] != line['UnitPrice']) {
                                line['UnitPrice'] = prices[j]['UnitPrice'];
                            }
                            break;
                        }
                    }
                }

                items.push({
                    ItemId: line.LineItem.ItemId,
                    ItemCode: line.LineItem.ItemCode,
                    Description: line.LineItem.Description,
                    Quantity: line.Quantity,
                    SalesUnitDesc: line.Unit.ShortDescription,
                    UnitPrice: line.UnitPrice,
                    SalesPrice: line.UnitPrice,
                    SalesUnitId: line.UnitId,
                    UnitId: line.UnitId,
                    GrossValue: SalesBasketManager.calcLineGrossValue(line)
                });
            }

            localStorage.setItem('basketItems', JSON.stringify(items));
        }

        if (_callback)
            _callback();
    }

    static get basketIsEmpty() {
        if (!localStorage.hasOwnProperty('basketItems'))
            return true;

        if (this.basketItems.length === 0)
            return true;

        return false;
    }
}


function getDateToday() {
    let today = new Date();
    let year = today.getFullYear().toString();
    let month = (today.getMonth() + 1).toString();
    let day = today.getDate().toString();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return (`${year}-${month}-${day}`);
}

export default SalesBasketManager;